import { flushSync } from "react-dom";
import { createRoot } from "react-dom/client";
import "./NitroMarker.css";

const typeMapping: { [type: string]: string } = {
  customer: "#8C12D8",
  koch: "#148DD3",
  competitor: "#C52F00",
  zipCodes: "#ababab",
  city: "#8a8a8a",
  kochAndCompetitor: "#000",
};

export const NitroMarkerBase = ({
  type,
  width,
  height,
  disabled,
}: {
  type: string;
  width?: number;
  height?: number;
  disabled?: boolean;
}) => {
  if (type === "kochAndCompetitor") {
    return (
      <svg
        opacity={disabled ? 0.3 : 1}
        width={width || 35}
        height={height || 35}
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: "#148DD3", stopOpacity: 1 }} />

          <stop offset="50%" style={{ stopColor: "#148DD3", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#C52F00", stopOpacity: 1 }} />
          <stop
            offset="100%"
            style={{ stopColor: "#C52F00", stopOpacity: 1 }}
          />
        </linearGradient>
        <circle cx="17" cy="14" r="7" fill="white" />
        <path
          d="M17.5 16.042C18.7081 16.042 19.6875 15.0626 19.6875 13.8545C19.6875 12.6464 18.7081 11.667 17.5 11.667C16.2919 11.667 15.3125 12.6464 15.3125 13.8545C15.3125 15.0626 16.2919 16.042 17.5 16.042Z"
          fill="url(#gradient1)"
          style={{ fill: "url(#gradient1)" }}
        />
        <path
          d="M17.5002 2.91699C14.4261 2.91684 11.4762 4.12997 9.29156 6.29273C7.10696 8.45548 5.86424 11.3931 5.8335 14.467C5.8335 22.4587 16.1147 31.3545 16.5522 31.7337C16.8164 31.9596 17.1526 32.0838 17.5002 32.0838C17.8478 32.0838 18.1839 31.9596 18.4481 31.7337C18.9585 31.3545 29.1668 22.4587 29.1668 14.467C29.1361 11.3931 27.8934 8.45548 25.7088 6.29273C23.5242 4.12997 20.5742 2.91684 17.5002 2.91699ZM17.5002 18.9587C16.4907 18.9587 15.5038 18.6593 14.6644 18.0985C13.8251 17.5376 13.1708 16.7404 12.7845 15.8078C12.3982 14.8751 12.2971 13.8488 12.4941 12.8587C12.691 11.8686 13.1771 10.9591 13.891 10.2453C14.6048 9.53147 15.5143 9.04535 16.5044 8.8484C17.4945 8.65146 18.5208 8.75254 19.4534 9.13886C20.3861 9.52518 21.1833 10.1794 21.7441 11.0188C22.305 11.8581 22.6043 12.845 22.6043 13.8545C22.6043 15.2082 22.0666 16.5065 21.1094 17.4637C20.1521 18.4209 18.8539 18.9587 17.5002 18.9587Z"
          fill="url(#gradient1)"
          style={{ fill: "url(#gradient1)" }}
        />
      </svg>
    );
  }

  return (
    <svg
      opacity={disabled ? 0.4 : 1}
      width={width || 35}
      height={height || 35}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17" cy="14" r="7" fill="white" />
      <path
        d="M17.5 16.042C18.7081 16.042 19.6875 15.0626 19.6875 13.8545C19.6875 12.6464 18.7081 11.667 17.5 11.667C16.2919 11.667 15.3125 12.6464 15.3125 13.8545C15.3125 15.0626 16.2919 16.042 17.5 16.042Z"
        fill={typeMapping[type] || "#FFF"}
      />
      <path
        d="M17.5002 2.91699C14.4261 2.91684 11.4762 4.12997 9.29156 6.29273C7.10696 8.45548 5.86424 11.3931 5.8335 14.467C5.8335 22.4587 16.1147 31.3545 16.5522 31.7337C16.8164 31.9596 17.1526 32.0838 17.5002 32.0838C17.8478 32.0838 18.1839 31.9596 18.4481 31.7337C18.9585 31.3545 29.1668 22.4587 29.1668 14.467C29.1361 11.3931 27.8934 8.45548 25.7088 6.29273C23.5242 4.12997 20.5742 2.91684 17.5002 2.91699ZM17.5002 18.9587C16.4907 18.9587 15.5038 18.6593 14.6644 18.0985C13.8251 17.5376 13.1708 16.7404 12.7845 15.8078C12.3982 14.8751 12.2971 13.8488 12.4941 12.8587C12.691 11.8686 13.1771 10.9591 13.891 10.2453C14.6048 9.53147 15.5143 9.04535 16.5044 8.8484C17.4945 8.65146 18.5208 8.75254 19.4534 9.13886C20.3861 9.52518 21.1833 10.1794 21.7441 11.0188C22.305 11.8581 22.6043 12.845 22.6043 13.8545C22.6043 15.2082 22.0666 16.5065 21.1094 17.4637C20.1521 18.4209 18.8539 18.9587 17.5002 18.9587Z"
        fill={typeMapping[type] || "#FFF"}
      />
    </svg>
  );
};

const NitroMarker = ({
  type,
  label,
  width = 300,
  hovering,
  selected,
  disabled,
  customBackgroundColor,
}: {
  type: string;
  label?: string;
  width?: number | string;
  hovering?: boolean;
  selected?: boolean;
  disabled?: boolean;
  customBackgroundColor?: string;
}) => {
  if (!typeMapping[type]) {
    console.warn("Missing marker type", { type });
  }

  let backgroundColor = customBackgroundColor || "white";

  if (selected) backgroundColor = "#005CA6";

  if (hovering) backgroundColor = "orange";

  return (
    <div
      style={{
        width,
        display: "flex",
        justifyContent: "center",
        position: "relative",
      }}
    >
      {label && (
        <div
          style={{ position: "absolute", top: 36, opacity: disabled ? 0.7 : 1 }}
        >
          <div
            style={{
              backgroundColor,
              padding: 5,
              borderRadius: 3,
              border: selected ? "3px solid #005CA6" : "1px solid #A7A9AB",
              fontSize: selected ? 12 : 10,
              fontWeight: 700,
              color: selected ? "white" : "#0F2C52",
            }}
          >
            {label}
          </div>
        </div>
      )}
      <div style={{ height: 35, width: 35, opacity: disabled ? 0.4 : 1 }}>
        <NitroMarkerBase type={type} />
      </div>
    </div>
  );
};

export default NitroMarker;

export const createNitroMarker = (
  type: string,
  label?: string,
  id?: string,
  hovering?: boolean,
  selected?: boolean,
  disabled?: boolean,
  customBackgroundColor?: string,
) => {
  const div = document.createElement("div");
  if (id) {
    div.id = id;
  }
  const root = createRoot(div);

  flushSync(() => {
    root.render(
      <NitroMarker
        type={type}
        label={label}
        hovering={hovering}
        selected={selected}
        disabled={disabled}
        customBackgroundColor={customBackgroundColor}
      />,
    );
  });

  return div;
};
